import {
  IgetTenantContactsAPIResponse,
  IgetBrandsAPIResponse,
  IgetBrandsProfileAPIResponse,
  IGetMyBrandsAPIResponse,
  TgetTenantPointsOfSaleAPIResponse,
  IshareDataWithBrandAPIResponse,
  IaddToMyBrandsBody,
  IaddToMyBrandsAPIResponse,
  IremoveFromMyBrandAPIResponse,
  IresendAssociationEmailAPIResponse,
} from 'api/endpoints/myBrands/myBrands.response.interface';
import { getBasePath } from '../../utils/config';
import { safeJsonParse, buildUrl } from 'api/utils/fetchHelpers';
import { IBrandsBodyFetchState } from 'interfaces/brands.interface';

export const getMyBrandsAPI = async ({
  clientId,
  stateId,
  token,
}: {
  clientId: string;
  stateId: string;
  token: string;
}): Promise<IGetMyBrandsAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/client_profile/get_client_brands_works`, {
      client_id: clientId,
      state_id: stateId,
    }),
    params
  );
  return await safeJsonParse(response);
};

export const removeFromMyBrandAPI = async ({
  associationId,
  token,
}: {
  associationId: string;
  token: string;
}): Promise<IremoveFromMyBrandAPIResponse> => {
  const params = {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/client_profile/delete_association_with_brand`, {
      association_id: associationId,
    }),
    params
  );
  return await safeJsonParse(response);
};

export const addToMyBrandsAPI = async ({
  body,
  token,
}: {
  body: IaddToMyBrandsBody;
  token: string;
}): Promise<IaddToMyBrandsAPIResponse> => {
  const params = {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(
    `${getBasePath()}/client_profile/create_association_with_brand`,
    params
  );
  return await safeJsonParse(response);
};

export const getBrandsProfileAPI = async ({
  brandId,
  token,
}: {
  brandId: string;
  token: string;
}): Promise<IgetBrandsProfileAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/brand_profile/get_brand_profile`, { brand_id: brandId }),
    params
  );
  return await safeJsonParse(response);
};

export const getBrandsAPI = async ({
  body,
  token,
}: {
  body: IBrandsBodyFetchState;
  token: string;
}): Promise<IgetBrandsAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/brand/search`, params);
  return await safeJsonParse(response);
};

export const getTenantPointsOfSaleAPI = async ({
  clientId,
  tenantId,
  token,
}: {
  clientId: string;
  tenantId: string;
  token: string;
}): Promise<TgetTenantPointsOfSaleAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/datashare/get_client_datashare`, {
      client_id: clientId,
      tenant_id: tenantId,
    }),
    params
  );
  return await safeJsonParse(response);
};

export const getTenantContactsAPI = async ({
  tenantId,
  token,
}: {
  tenantId: string;
  token: string;
}): Promise<IgetTenantContactsAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/brand_profile/get_brand_contacts`, {
      tenant_id: tenantId,
    }),
    params
  );
  return await safeJsonParse(response);
};

export const shareDataWithBrandAPI = async ({
  datashareId,
  value,
  token,
}: {
  datashareId: string;
  value: boolean;
  token: string;
}): Promise<IshareDataWithBrandAPIResponse> => {
  const params = {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify([
      {
        data_share_id: datashareId,
        data_share: value,
      },
    ]),
  };
  const response = await fetch(
    `${getBasePath()}/datashare/update_client_datashare`,
    params
  );
  return await safeJsonParse(response);
};

export const resendAssociationEmailAPI = async ({
  tenantId,
  clientId,
  to,
  token,
}: {
  tenantId: string;
  clientId: string;
  to?: { email: string; name: string };
  token: string;
}): Promise<IresendAssociationEmailAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(
      !to
        ? {
            tenant_id: tenantId,
            client_id: clientId,
          }
        : {
            tenant_id: tenantId,
            client_id: clientId,
            to: [
              {
                email: to.email,
                name: to.name,
              },
            ],
          }
    ),
  };
  const response = await fetch(
    `${getBasePath()}/notification/request_association`,
    params
  );
  return await safeJsonParse(response);
};
